import React from 'react';
import { Avatar } from '@cian/ui-kit';

import { IconTrust16 } from '../Icons';
import s from './UserCard.css';

interface IUserCardParams {
  /** Ссылка на изображение */
  imageSrc?: string;
  /** Имя пользователя */
  name: string;
  /** Описание */
  description?: string;
  /** Размер */
  size?: 'M' | 'XS';
  /** Иконка доверенного пользователя */
  isTrusted?: boolean;
  /** Ссылка пользователя */
  url?: string;
  /** Событие клика */
  onClick?(e: React.MouseEvent): void;
}

/**
 * Карточка пользователя
 */
export const UserCard = ({
  imageSrc,
  name,
  description,
  size = 'M',
  isTrusted = false,
  url,
  onClick,
}: IUserCardParams) => {
  const handleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault();
    e.stopPropagation();

    if (onClick) {
      onClick(e);
    }
  };

  return (
    <div className={s['wrapper']}>
      <div className={s['image']} onClick={handleClick}>
        {url ? (
          <a href={url} onClick={handleClick}>
            <Avatar src={imageSrc} type="user" size={size === 'M' ? 40 : 30} />
          </a>
        ) : (
          <Avatar src={imageSrc} type="user" size={size === 'M' ? 40 : 30} />
        )}
      </div>

      <div className={s['content']}>
        <div className={s['name-wrapper']}>
          {url ? (
            <a href={url} className={s['name']} onClick={handleClick} title={name}>
              {name}
            </a>
          ) : (
            <div className={s['name']} onClick={handleClick} title={name}>
              {name}
            </div>
          )}

          {isTrusted && <IconTrust16 />}
        </div>

        {description && (
          <div className={s['description']} title={description}>
            {description}
          </div>
        )}
      </div>
    </div>
  );
};
